import React, { useEffect, useState } from 'react';
import { func, object } from 'prop-types';

import Input from 'library/components/form-components/input';
import Dropdown from 'library/components/form-components/dropdown2';
import { QuestionBody } from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/styled-question';

const phoneOptions = [
  {
    value: 'mobile',
    label: 'Mobile',
  },
  {
    value: 'home',
    label: 'Home',
  },
  {
    value: 'work',
    label: 'Work',
  },
];

const Phone = ({ answer, question, handleChange }) => {
  const [storedValues, setStoredValues] = useState({});

  useEffect(() => {
    if (answer) setStoredValues(answer);
  }, [question.id]);
  // remove space and delimiters from phone number for consistent data
  const handlePhoneChange = (e) => {
    let sanitized = e.target.value.replace(/\.|-|\s/g, '');
    handleChange({ target: { name: 'phone_number', value: sanitized } });
  };

  return (
    <QuestionBody question={question}>
      <Input
        required
        pattern="([0-9]{3}(\.|-|\s){1}[0-9]{3}(\.|-|\s){1}[0-9]{4})|([0-9]{10})"
        name="phone_number"
        aria-label="Enter a 10 digit phone number"
        label="303-123-4567"
        type="tel"
        onChange={handlePhoneChange}
        value={storedValues['phone_number']}
      />
      <Dropdown
        required
        options={phoneOptions}
        name="number_type"
        ariaLabel="Select a contact number type"
        label="Select a contact number type"
        onChange={handleChange}
        value={storedValues['number_type']}
      />
    </QuestionBody>
  );
};

Phone.propTypes = {
  answer: object,
  question: object,
  handleChange: func,
};

export default Phone;
